"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Ποιες είναι οι ώρες λειτουργίας σας;",
  answer: "Το γραφείο μας λειτουργεί από Δευτέρα έως Παρασκευή, 09:00 με 17:00."
}, {
  question: "Πώς μπορώ να κλείσω ένα ραντεβού;",
  answer: "Μπορείτε να κλείσετε ραντεβού τηλεφωνικά καλώντας στο τηλεφωνικό μας κέντρο ή συμπληρώνοντας τη φόρμα επικοινωνίας στην ιστοσελίδα μας."
}, {
  question: "Ποιοι είναι οι τρόποι πληρωμής που δέχεστε;",
  answer: "Δεχόμαστε πληρωμές με όλες τις γνωστές πιστωτικές και χρεωστικές κάρτες και μέσω τραπεζικής μεταφοράς."
}, {
  question: "Προσφέρετε υπηρεσίες εκτός της περιοχής σας;",
  answer: "Ναι, αναλαμβάνουμε έργα και παρέχουμε τις υπηρεσίες μας σε όλη την Ελλάδα, κατόπιν σχετικής συνεννόησης και προγραμματισμού."
}, {
  question: "Ποιος είναι ο εκτιμώμενος χρόνος επιβεβαίωσης της κράτησης μου;",
  answer: "Άμεσα! Με τη κράτηση σας λαμβάνετε email στη διεύθυνση που έχετε δηλώσει με το voucher της κράτησης"
}, {
  question: "Παρέχετε υποστήριξη μετά την κράτηση;",
  answer: "Φυσικά, προσφέρουμε συνεχή υποστήριξη μέσω του webchat, email, social media και Viber-Whatsapp"
}];
export default function FaqAccordion() {
  return <section id="faq-accordion" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-3xl">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index}>
              <AccordionTrigger className="text-left font-default text-lg text-foreground hover:text-primary transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}